import React from "react";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
import "./scss/style.scss";
import { connect } from "react-redux";

import Page404 from "./views/pages/page404/Page404";
import Login from "./views/pages/login/Login";
import TheLayout from "./containers/TheLayout";
import TheClientLayout from "./clientcontainer/TheClientLayout";

const App = ({ userToken, isHandler, isClient, isLoading, ...props }) => {
  const checkHandler = () => userToken && isHandler;
  const checkClient = () => userToken && isClient;

  window.sessionStorage.removeItem("userToken");
  window.sessionStorage.removeItem("isClient");
  window.sessionStorage.removeItem("isHandler");

  function HandlerRoute({ component: Component, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) =>
          checkHandler() ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          )
        }
      />
    );
  }

  function ClientRoute({ component: Component, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) =>
          checkClient() ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          )
        }
      />
    );
  }

  return (
    <BrowserRouter>
      <Switch>
        <Route
          exact
          path="/"
          name="Login Page"
          render={(props) => <Login {...props} />}
        />
        <ClientRoute path="/clientpage" component={TheClientLayout} />

        <HandlerRoute path="/handler" component={TheLayout} />
        <Route component={Page404} />
      </Switch>
    </BrowserRouter>
  );
};
//
function mapStateToProps(state) {
  return {
    userToken: state.userTokenReducer.userToken,
    isClient: state.userTokenReducer.isClient,
    isHandler: state.userTokenReducer.isHandler,
    isLoading: state.userTokenReducer.isLoading,
  };
}

export default connect(mapStateToProps)(App);
